import { ElementRef, Renderer2 } from '@angular/core';
import { Subject } from 'rxjs';
var ImageZoomComponent = /** @class */ (function () {
    function ImageZoomComponent(render) {
        this.render = render;
        this.zoom = 1;
        this.lenSize = 60;
        this.posX = 0;
        this.posY = 0;
        this.cx = 1;
        this.cy = 1;
        this.yet = false;
        this.mouseMovement = new Subject();
    }
    ImageZoomComponent.prototype.mouseMove = function (event) {
        // this.render.setStyle(this.divZoomed, 'display', 'block');
        this.render.setStyle(this.divZoomed, 'visibility', 'visible');
        var result = this.moveLens(event);
        this.render.setStyle(this.divZoomed, 'background-position', result);
    };
    ImageZoomComponent.prototype.mouseLeave = function (event) {
        // this.render.setStyle(this.divZoomed, 'display', 'none');
        this.render.setStyle(this.divZoomed, 'visibility', 'hidden');
    };
    ImageZoomComponent.prototype.onLoad = function () {
        var _this = this;
        this.render.setStyle(this.divZoomed, 'visibility', 'hidden');
        this.render.setStyle(this.divZoomed, 'background-image', "url('" + this.imagen + "')");
        this.render.setStyle(this.divZoomed, 'background-size', (this.img.nativeElement.naturalWidth * this.zoom) + "px " + (this.img.nativeElement.naturalHeight * this.zoom) + "px");
        this.render.setStyle(this.divZoomed, 'background-repeat', 'no-repeat');
        this.render.setStyle(this.divZoomed, 'transition', 'background-position .2s ease-out');
        this.factorX = this.img.nativeElement.naturalWidth;
        this.factorY = this.img.nativeElement.naturalHeight;
        this.yet = true;
        setTimeout(function () {
            _this.factorX = _this.imgWidth || _this.img.nativeElement.offsetHeight ? _this.factorX / _this.img.nativeElement.width : 1;
            _this.factorY = _this.imgWidth || _this.img.nativeElement.offsetHeight ? _this.factorY / _this.img.nativeElement.height : 1;
            var dim = _this.divZoomed.getBoundingClientRect();
            _this.cx = (dim.width - _this.img.nativeElement.width * _this.zoom * _this.factorX) / (_this.img.nativeElement.width - _this.lens.nativeElement.offsetWidth);
            _this.cy = (dim.height - _this.img.nativeElement.height * _this.zoom * _this.factorY) / (_this.img.nativeElement.height -
                _this.lens.nativeElement.offsetHeight);
        });
    };
    ImageZoomComponent.prototype.moveLens = function (e) {
        var pos;
        var x;
        var y;
        /*prevent any other actions that may occur when moving over the image:*/
        e.preventDefault();
        /*get the cursor's x and y positions:*/
        pos = this.getCursorPos(e);
        /*calculate the position of the lens:*/
        x = pos.x - (this.lens.nativeElement.offsetWidth / 2);
        y = pos.y - (this.lens.nativeElement.offsetHeight / 2);
        /*prevent the lens from being positioned outside the image:*/
        if (x > this.img.nativeElement.width - this.lens.nativeElement.offsetWidth) {
            x = this.img.nativeElement.width - this.lens.nativeElement.offsetWidth;
        }
        if (x < 0) {
            x = 0;
        }
        if (y > this.img.nativeElement.height - this.lens.nativeElement.offsetHeight) {
            y = this.img.nativeElement.height - this.lens.nativeElement.offsetHeight;
        }
        if (y < 0) {
            y = 0;
        }
        /*set the position of the lens:*/
        this.posX = x;
        this.posY = y;
        /*display what the lens "sees":*/
        var result = (x * this.cx) + "px " + (y * this.cy) + "px";
        return result;
    };
    ImageZoomComponent.prototype.getCursorPos = function (e) {
        var a, x = 0, y = 0;
        e = e || window.event;
        /*get the x and y positions of the image:*/
        a = this.img.nativeElement.getBoundingClientRect();
        /*calculate the cursor's x and y coordinates, relative to the image:*/
        x = e.pageX - a.left;
        y = e.pageY - a.top;
        /*consider any page scrolling:*/
        x = x - window.pageXOffset;
        y = y - window.pageYOffset;
        return { x: x, y: y };
    };
    return ImageZoomComponent;
}());
export { ImageZoomComponent };
